import {
    ReactElement,
    HTMLAttributes,
} from "react";
interface Props extends HTMLAttributes<HTMLElement> {

    myStyle: string;
    text?: string;
    value?: string;
    lable?: string;
    unit?:string

}

export function InfoCard({ myStyle , text , value , lable , unit }: Props, props: any): ReactElement {

    return (

        <div className={`${myStyle ? myStyle : ""} info-card`} >
            <span className="info-card-text info-card-lable">{lable}</span>
            <div className="info-card-content">
                <span className="info-card-text">
                    {value} {unit && 
                    <>
                     | {unit}
                    </> }
                </span>
                <span className="info-card-text">
                    {text}
                </span>
            </div>

        </div>
    );
}

export default InfoCard;